import { motion } from "framer-motion";
import { waLink } from "@/config/site";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Scrivici su WhatsApp"
      className="wa-pulse group fixed right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25d366] text-white shadow-[0_16px_36px_-12px_rgba(31,175,87,0.65)] transition-transform duration-300 hover:scale-105 active:scale-95"
      style={{ bottom: "calc(1.25rem + env(safe-area-inset-bottom, 0px))" }}
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <WhatsAppIcon className="h-7 w-7" />
      <span className="font-display pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full border border-black/[0.06] bg-white px-4 py-2 text-sm font-bold text-[#1c1d1f] opacity-0 shadow-lg transition-opacity duration-300 group-hover:opacity-100 sm:block">
        Scrivici su WhatsApp
      </span>
    </motion.a>
  );
}
